module.exports = __webpack_public_path__ + "img/varoszoba_onarckep.ba111a87.jpg";